import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { Grid, Form, Button, Header, Accordion, Icon } from 'semantic-ui-react';

import { DatePickerField, CheckboxField } from 'Common/SemanticWrapper';
import { TitledCard, DatePickerCustomButton } from 'Components';
import { ITEM_MAINTENANCE_TRANSACTION_DETAILS_FORM_NAME } from 'Common/FormEnum';
import {
  getTransactionData,
  printReportData,
  clearReport,
} from './../state/addEditItem/actions';
import { TransactionDetailsEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI, DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { ReportGeneration } from 'Common/ObjectHelper';
import { toastInfo } from 'Common/ToastHelper';

import 'PageStyles/schoolcalendar/index.less';
import { validateTransactionDetailsForm } from '../helpers';
import { TransactionDetailTable } from './tables/TransactionDetailTable';

class TransactionDetails extends Component {
  constructor(props) {
    super(props);
    const currentDate = moment();

    const {
      Adjustment,
      Order,
      Physical,
      Receipt,
      Transfer,
      Usage,
    } = this.props.initialValues;

    this.state = {
      fromDateMin: null,
      fromDateMax: currentDate,
      toDateMin: null,
      resetPageOnDataChange: true,
      activeIndexes: [0],
      [TransactionDetailsEnum.Adjustment]: Adjustment,
      [TransactionDetailsEnum.Order]: Order,
      [TransactionDetailsEnum.Physical]: Physical,
      [TransactionDetailsEnum.Receipt]: Receipt,
      [TransactionDetailsEnum.Transfer]: Transfer,
      [TransactionDetailsEnum.Usage]: Usage,
    };
    this.reactTable = React.createRef();
  }

  componentDidMount() {
    this.getInitialGridData();
  }

  componentDidUpdate(prevProps) {
    const { report } = this.props;
    if (prevProps.report !== report && report != null) {
      if (report) {
        ReportGeneration(report, 'Transaction Detail Report');
      } else {
        toastInfo('No data found!');
      }
      this.props.clearReport();
    }
  }

  handleCollapsePanelClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexes } = this.state;
    const activeIndexesClone = [...this.state.activeIndexes];
    activeIndexes.indexOf(index) !== -1
      ? activeIndexesClone.splice(activeIndexes.indexOf(index), 1)
      : activeIndexesClone.push(index);
    this.setState({ activeIndexes: activeIndexesClone });
  };

  clearFilters = () => {
    const currentDate = moment();
    this.props.reset();
    this.setState({
      filtered: [],
      fromDateMax: currentDate,
      fromDateMin: null,
      toDateMin: null,
    });

    if (this.props.initialValues) {
      const {
        initialValues: {
          BeginDT,
          EndDT,
          Adjustment,
          Order,
          Physical,
          Receipt,
          Transfer,
          Usage,
        },
        id,
        getTransactionData,
      } = this.props;
      const fetchData = {
        ItemId: id,
        FromDate: moment(BeginDT).format(DATE_FORMAT_FOR_SERVER),
        ToDate: moment(EndDT).format(DATE_FORMAT_FOR_SERVER),
        TransactionType: {
          Adjustment,
          Order,
          Physical,
          Receipt,
          Transfer,
          Usage,
        },
      };
      getTransactionData(fetchData);
    }
  };

  getInitialGridData = () => {
    const { id, getTransactionData } = this.props;
    const {
      BeginDT,
      EndDT,
      Adjustment,
      Order,
      Physical,
      Receipt,
      Transfer,
      Usage,
    } = this.props.initialValues;

    const fetchData = {
      ItemId: id,
      FromDate: BeginDT,
      ToDate: EndDT,
      TransactionType: {
        Adjustment: Adjustment,
        Order: Order,
        Physical: Physical,
        Receipt: Receipt,
        Transfer: Transfer,
        Usage: Usage,
      },
    };
    getTransactionData(fetchData);
  };

  handleCheckBoxChange = (e, newValue, prevValue, field) => {
    this.setState({ [TransactionDetailsEnum[field]]: newValue }, () => {
      this.getFilterData(newValue, prevValue, field);
    });
  };

  getFilterData = (newValue, prevValue, field) => {
    const {
      Adjustment,
      Order,
      Physical,
      Receipt,
      Transfer,
      Usage,
    } = this.state;
    const { id, getTransactionData, beginDT, endDT } = this.props;

    let beginDate = beginDT;
    let endDate = endDT;

    if (field === TransactionDetailsEnum.BeginDT) {
      beginDate = newValue;
    }
    if (field === TransactionDetailsEnum.EndDT) {
      endDate = newValue;
    }
    //on call from componentDidMount props will be undefined so need to use !! on adjustment,order etc.
    if (beginDate && endDT) {
      const fetchData = {
        ItemId: id,
        FromDate: moment(beginDate).format(DATE_FORMAT_FOR_SERVER),
        ToDate: moment(endDate).format(DATE_FORMAT_FOR_SERVER),
        TransactionType: {
          Adjustment: Adjustment,
          Order: Order,
          Physical: Physical,
          Receipt: Receipt,
          Transfer: Transfer,
          Usage: Usage,
        },
      };
      getTransactionData(fetchData);
    }
  };
  onChangeOfFromDT = (e, newValue, prevValue, field) => {
    this.selectFromDate(e, newValue, prevValue, field);
  };
  onChangeOfToDT = (e, newValue, prevValue, field) => {
    this.selectToDate(e, newValue, prevValue, field);
  };
  selectFromDate(e, newValue, prevValue, field) {
    this.setState(
      {
        toDateMin: moment(newValue, DATE_FORMAT_FOR_UI),
        resetPageOnDataChange: true,
      },
      () => this.getFilterData(newValue, prevValue, field)
    );
  }

  selectToDate(e, newValue, prevValue, field) {
    this.setState(
      {
        fromDateMax: moment(newValue, DATE_FORMAT_FOR_UI),
        resetPageOnDataChange: true,
      },
      () => this.getFilterData(newValue, prevValue, field)
    );
  }
  onResetPageOnDataChange = () => {
    this.setState({ resetPageOnDataChange: false });
  };
  render() {
    const { transactionDetailsData, fetchingTransaction } = this.props;

    return (
      <Form>
        <Accordion fluid styled>
          <Accordion.Title
            active={this.state.activeIndexes.indexOf(0) !== -1}
            index={0}
            onClick={this.handleCollapsePanelClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>

          <Accordion.Content
            active={this.state.activeIndexes.indexOf(0) !== -1}
          >
            <Grid className="grid-spacing">
              <Grid.Row columns={2}>
                <Grid.Column>
                  <div style={{ paddingTop: '25px' }}>
                    <Header as="h4">Transaction Date Range</Header>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={4}>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    customInput={<DatePickerCustomButton />}
                    label={'From:'}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={TransactionDetailsEnum.BeginDT}
                    onChange={this.onChangeOfFromDT}
                    maxDate={this.state.fromDateMax}
                    minDate={this.state.fromDateMin}
                    type={'text'}
                    dropdownMode="select"
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    customInput={<DatePickerCustomButton />}
                    label={'To:'}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={TransactionDetailsEnum.EndDT}
                    type={'text'}
                    onChange={this.onChangeOfToDT}
                    minDate={this.state.toDateMin}
                    dropdownMode="select"
                  />
                </Grid.Column>
                <Grid.Column
                  floated={'right'}
                  textAlign={'right'}
                  style={{ marginTop: '35px' }}
                >
                  <Button content="Reset Filters" onClick={this.clearFilters} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <TitledCard title={'TransactionType'}>
              <Grid className="tight">
                <Grid.Row columns={6}>
                  <Grid.Column>
                    <Field
                      name={TransactionDetailsEnum.Adjustment}
                      component={CheckboxField}
                      toggle
                      label={'Adjustment'}
                      onChange={this.handleCheckBoxChange}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Field
                      name={TransactionDetailsEnum.Order}
                      component={CheckboxField}
                      toggle
                      label={'Order'}
                      onChange={this.handleCheckBoxChange}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Field
                      name={TransactionDetailsEnum.Physical}
                      component={CheckboxField}
                      toggle
                      label={'Physical'}
                      onChange={this.handleCheckBoxChange}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Field
                      name={TransactionDetailsEnum.Receipt}
                      component={CheckboxField}
                      toggle
                      label={'Receipt'}
                      onChange={this.handleCheckBoxChange}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Field
                      name={TransactionDetailsEnum.Transfer}
                      component={CheckboxField}
                      toggle
                      label={'Transfer'}
                      onChange={this.handleCheckBoxChange}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Field
                      name={TransactionDetailsEnum.Usage}
                      component={CheckboxField}
                      toggle
                      label={'Usage'}
                      onChange={this.handleCheckBoxChange}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </TitledCard>
          </Accordion.Content>
        </Accordion>

        <Grid>
          <Grid.Row
            columns={8}
            style={{
              marginTop: 20,
            }}
          >
            <Grid.Column
              floated={'right'}
              textAlign={'right'}
              verticalAlign={'bottom'}
            ></Grid.Column>
          </Grid.Row>
        </Grid>

        <TitledCard>
          <Grid>
            <Grid.Row columns={1} className={'remove-spacing'}>
              <Grid.Column>
                <TransactionDetailTable
                  transactionDetailsData={transactionDetailsData}
                  fetchingTransaction={fetchingTransaction}
                  resetPageOnDataChange={this.state.resetPageOnDataChange}
                  onResetPageOnDataChange={this.onResetPageOnDataChange}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const selector = formValueSelector(
  ITEM_MAINTENANCE_TRANSACTION_DETAILS_FORM_NAME
);
const mapStateToProps = state => {
  const { addEditItem } = state.ItemMaintenanceState;
  const { gridPreference } = state.CommonState;
  return {
    transactionDetailsData: addEditItem.transactionDetailsData,
    fetchingTransaction: addEditItem.fetchingTransaction,
    beginDT: selector(state, TransactionDetailsEnum.BeginDT),
    endDT: selector(state, TransactionDetailsEnum.EndDT),
    gridPreferenceData: gridPreference.preferenceJson,
    gridPreferenceLoading: gridPreference.loading,
    gridPreferenceSubmitting: gridPreference.isSubmitting,
    printLoading: addEditItem.printLoading,
    report: addEditItem.report,
  };
};

TransactionDetails = reduxForm({
  validate: validateTransactionDetailsForm,
  destroyOnUnmount: false,
  form: ITEM_MAINTENANCE_TRANSACTION_DETAILS_FORM_NAME,
})(TransactionDetails);

export default connect(mapStateToProps, {
  getTransactionData,
  printReportData,
  clearReport,
})(TransactionDetails);



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/components/TransactionDetails.js